/**
 * Meta Pixel event tracking utilities.
 *
 * INERT BY DEFAULT — no Meta Pixel is loaded, so window.fbq never exists and
 * every helper below is a no-op. This is deliberate: Clinivo does not ship
 * placeholder tracking code. To activate, paste the standard Meta Pixel
 * snippet into index.html with a real pixel ID from Meta Events Manager
 * (https://www.facebook.com/events_manager).
 */

function fbq(...args) {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(...args);
  }
}

/** Fire when a candidate views a job detail page */
export function trackJobView(job) {
  if (!job) return;
  fbq('track', 'ViewContent', {
    content_type: 'job',
    content_ids: [job.id],
    content_name: job.title,
    content_category: job.specialty || 'Healthcare',
    value: 1,
    currency: 'USD',
  });
}

/** Fire when a candidate submits a job application (Lead conversion) */
export function trackApplicationSubmitted(job, application) {
  fbq('track', 'Lead', {
    content_type: 'job',
    content_ids: [job?.id],
    content_name: job?.title,
    content_category: job?.specialty || 'Healthcare',
    currency: 'USD',
    value: 15,
  });
}

/** Fire when a candidate opens the application modal (initiates application) */
export function trackApplicationStarted(job) {
  fbq('track', 'InitiateCheckout', {
    content_type: 'job',
    content_ids: [job?.id],
    content_name: job?.title,
    content_category: job?.specialty || 'Healthcare',
    currency: 'USD',
    value: 15,
  });
}

/** Fire when an employer starts the job posting flow */
export function trackJobPostingStarted() {
  fbq('track', 'AddToCart', {
    content_type: 'job_posting',
    currency: 'USD',
    value: 99,
  });
}

/** Fire when an employer completes signup / facility setup (registration conversion) */
export function trackEmployerRegistered(facilityName) {
  fbq('track', 'CompleteRegistration', {
    content_name: facilityName || 'Healthcare Employer',
    status: 'completed',
    currency: 'USD',
    value: 99,
  });
}

/** Fire when a user starts a checkout session for a subscription plan */
export function trackSubscriptionCheckout(planName, amount) {
  fbq('track', 'StartTrial', {
    content_name: planName,
    currency: 'USD',
    value: amount || 0,
  });
}

/** Fire a custom event for specialty page views (useful for audience segmentation) */
export function trackSpecialtyView(specialty) {
  fbq('trackCustom', 'SpecialtyView', { specialty });
}

/** Generic page view tracking for SPA route changes */
export function trackPageView() {
  fbq('track', 'PageView');
}